module.exports = __webpack_public_path__ + "media/images/beauty/agathe@2x-4228a3deec468aafd50046056cbebaf0.jpg";